import { getAppTheme, userIsSubscriber } from 'components/Utils/theme';
import { AccountContext } from 'components/AccountContext';
import { useContext, useState } from 'react';
import { api } from 'api/api';
import { useNavigate, useSearchParams } from 'react-router-dom';

const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;

const useModelAvaliacaoLoja = () => {
  const { user } = useContext(AccountContext);
  const theme = getAppTheme(userIsSubscriber(user));
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchParams] = useSearchParams();
  const [success, setSuccess] = useState(false);
  const [showIOSButton, setShowIOSButton] = useState(false);

  const detectDevice = () => {
    const userAgent = navigator.userAgent;
    if (/android/i.test(userAgent)) {
      return 'Android';
    }

    const isIOS = /iPhone|iPad|iPod/i.test(userAgent);

    if (isIOS) {
      if (/wv/i.test(userAgent) || /Chrome|Chromium/i.test(userAgent)) {
        return 'Android';
      }
      return 'iOS';
    }
  };

  const device = searchParams.get('platform') ?? detectDevice();

  const navigate = useNavigate();

  const abrirAppStore = () => {
    window.open('https://apps.apple.com/app/id1545985928?action=write-review', '_blank');
    setSuccess(true);
    setShowIOSButton(false);
  };

  async function registrarCliqueAvaliacao(status_clique, agenda_exames_id, disclosure) {
    setError(null);
    setLoading(true);

    const payload = {
      cpf: user.username,
      status_clique: status_clique,
      agenda_exames_id: agenda_exames_id,
    };

    try {
      await api(`${ENDPOINT}/clients/registrarCliqueAvaliacao`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      })
        .then(async (res) => {
          if (!res || !res.ok || res.status >= 400) {
            setError(true);
            setLoading(false);
            return;
          }
          return await res.json();
        })
        .then(async (resposta) => {
          if (!resposta || !resposta.success) {
            console.log(resposta);
            setError(true);
            setLoading(false);
            return;
          }

          if (status_clique === 'AVALIAR_AGORA') {
            if (user.device === 'ios' || user.device === 'iOS') {
              setSuccess(false);
              setShowIOSButton(true);
              return;
            }
            if (user.device === 'android' || user.device === 'Android') {
              setSuccess(true);
              window.open('https://play.google.com/store/apps/details?id=com.deovita.app', '_blank');
              disclosure.onClose();
              return;
            }
            setSuccess(true);
            window.open('https://play.google.com/store/apps/details?id=com.deovita.app', '_blank');
            disclosure.onClose();
            return;
          }

          navigate('/dashboard');
        });
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  }

  return {
    theme,
    loading,
    error,
    registrarCliqueAvaliacao,
    success,
    showIOSButton,
    abrirAppStore,
    user
  };
};

export default useModelAvaliacaoLoja;
